/**
 * Ensures user-state `version` is a non-negative integer for API calls and Redux.
 * Corrupted persisted values (string, float, NaN) otherwise produce RTK bodies like
 * `"version":"1"` or `version:null` (NaN JSON), which the API rejects with 400.
 */
export function normalizeUserStateVersion(value: unknown): number {
  if (typeof value === "number") {
    if (!Number.isFinite(value) || !Number.isInteger(value) || value < 0) {
      return 0;
    }
    return value;
  }
  if (typeof value === "string" && value.trim() !== "") {
    const n = Number(value);
    if (Number.isFinite(n) && Number.isInteger(n) && n >= 0) {
      return n;
    }
  }
  return 0;
}
